import type { MouseEvent } from 'react';
import { buildConversationPath } from '@/entities/conversations';
import { preventShiftSelection } from '@/shared/lib';

/** Пропсы ссылки на диалог: адрес и перехват нажатия. Оформление задаёт сама строка. */
type ConversationLinkProps = {
  href: string;
  onMouseDown: (event: MouseEvent) => void;
  onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * Собирает строку дашборда, ведущую в диалог: адрес видно и можно скопировать, но переход
 * выполняем сами — по shift браузер открыл бы окно, а не вкладку.
 *
 * Отдаёт пропсы, а не готовую строку: строки, ведущие в диалог, у блоков дашборда разные
 * (карточка топ-звонка — консультант с баллом, строка списка диалогов — название с величиной),
 * общее у них только правило перехода. Функция, а не хук: список диалогов собирает такие
 * строки в цикле.
 */
export const getConversationLinkProps = (
  conversationId: number,
  onOpen: (conversationId: number, openInNewTab: boolean) => void,
): ConversationLinkProps => ({
  href: buildConversationPath(conversationId),
  onMouseDown: preventShiftSelection,
  onClick: (event) => {
    event.preventDefault();
    onOpen(conversationId, event.shiftKey);
  },
});

/**
 * Гасит выделение текста по shift+нажатию строки таблицы, ведущей к диалогам. Таблица кита не
 * принимает нажатие строки, пока в документе что-то выделено, — а shift тянет выделение от
 * прежнего места нажатия (например, оставшегося после возврата из диалога), и переход в новой
 * вкладке молча пропадал бы. Нажатия вне строк — заголовки, панели — не трогаются.
 */
export const preventRowShiftSelection = (event: MouseEvent): void => {
  if (event.target instanceof Element && event.target.closest('[data-ibs-dg-row]')) preventShiftSelection(event);
};
